import { FC, useMemo } from 'react'

import { IconEyeOpen, GreyGrey30, Flex } from '@sequencehq/core-components'
import { ReactQuoteRenderer } from '@sequencehq/quote-content'
import { dashboard20240730Client } from '@sequencehq/api/dashboard/v20240730'
import { Customer, Quote, Requestor } from '../../../types'
import { UserAction } from 'Automations/components'
import { toQuoteRendererData } from './utils'

export const QuotePreview: FC<{
  quote: Quote
  customer: Customer
  requestor: Requestor
  createdAt: string
}> = ({ quote, customer, requestor, createdAt }) => {
  return (
    <Flex flexDir="column" overflow="hidden" height="100%">
      <Flex
        borderBottom={`${GreyGrey30} 1px solid`}
        paddingX="16px"
        paddingY="12px"
      >
        <UserAction
          icon={<IconEyeOpen />}
          label="Quote sent for approval"
          performedBy={requestor.email || ''}
          timestamp={createdAt}
        />
      </Flex>

      <Flex flex="1" overflowY="auto">
        <Renderer quote={quote} customer={customer} />
      </Flex>
    </Flex>
  )
}

const Renderer: FC<{ quote: Quote; customer: Customer }> = ({
  quote,
  customer
}) => {
  const data = useMemo(
    () => toQuoteRendererData({ quote, customer }),
    [quote, customer]
  )

  return (
    <ReactQuoteRenderer
      data={data}
      assetLoader={async ({ assetId }) => {
        const res = await dashboard20240730Client.getAsset({
          id: assetId
        })

        if (!res.data || res.error) {
          return undefined
        }

        return { urlSigned: res.data.url }
      }}
      trailingSideContent={undefined}
      forceLatestPresentationStyling
    />
  )
}
